export default {
  props: {
    fileId: { // 文件id
      type: String,
      required: true,
      default: ''
    },
    start: { // 开始页
      type: Number,
      default: 0
    },
    // 真实水印 真｜假
    showWatermark: {
      type: Boolean,
      default: true
    },
    watermarkCode: { // 假水印的appCode
      type: String,
      default: ''
    },
    watermarkConfig: { // 假水印的自定义水印参数
      type: Object,
      default: () => ({})
    },
    watermarkOrgId: { // 特定机构水印配置
      type: String,
      default: ''
    },
    serverGroupId: { // 私有云获取播放地址
      type: [String, Number],
      default: undefined
    },
    virtual: {
      type: [Boolean, String],
      default: false
    }
  }
};
